import CashbackActionType from 'actions/cashBack/cashBackActionType';

const initialState = {
  cashBack: {},
};

const cashBackReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case CashbackActionType.SAVE_CASH_BACK:
    return {
      ...state,
      cashBack: payload.data,
    };
  case CashbackActionType.RESET_CASH_BACK:
    return {
      ...state,
      cashBack: {},
    };
  default:
    return state;
  }
};

export default cashBackReducer;
